(function initPawPrintConfig() {
  const salesPages = [
    window.OFFER_TYPES.PUZZLE,
    window.OFFER_TYPES.COLORING_BOOK,
    window.OFFER_TYPES.NEW_CALENDAR,
    window.OFFER_TYPES.BOX_CLUB,
    window.OFFER_TYPES.CARTOON_PUZZLE,
    window.OFFER_TYPES.MAGNET,
    window.OFFER_TYPES.CARTOON_CALENDAR,
    window.OFFER_TYPES.PET_PORTRAIT_BRACELET,
  ]

  function shouldUseProd(){
    const host = window.location.host.toLowerCase()
    const PRODUCTION_URL = 'thepawprint.store'
    const STAGING_URL = 'tpp-testing.myshopify.com'
    const isInPreviewPageOfStaging = document.title.toLowerCase().includes('testing')

    if (host === PRODUCTION_URL){
      return true;
    }

    if (host === STAGING_URL){
      return false;
    }

    return !isInPreviewPageOfStaging;
  }

   const specificEnvironmentConfig = shouldUseProd() ? {
    baseApiUrl: 'https://graceful-bangkok-iw65tkusq7pq.vapor-farm-f1.com/api/p',
    apiToken: '8|Lbzw11IZ69ngpq487U6xduLAP1dFRrTmn0gBA5XM38914037',
  } : {
    baseApiUrl: 'https://staging.tppadmin.tech/api/p',
    apiToken: '1|Sl0lfErGrqJrqQAHUxyBFNGgfwJVDREbx0Mdqg4m961f0230',
  };

  window.pawPrintConfig = {
    fApiToken: 'd555b4c8-fd56-449d-9a97-baf2016a7130',
    latestOfferAssemblyUrl: 'https://apif.thepawprint.store/offers/submission-assembly/latest',
    latestOfferAssemblyAuth: '636cec0e-25ee-43dc-90f8-9e145036d383',
    calendarImageCacheUrl: 'https://apif.thepawprint.store/submissions/cache-images',
    calendarImageCacheAuth: '636cec0e-25ee-43dc-90f8-9e145036d383',
    submissionGalleryUrl: 'https://apif.thepawprint.store/submissions/lookup',
    submissionGalleryAuth: '636cec0e-25ee-43dc-90f8-9e145036d383',
    calendarAssemblyCarouselUrlAllowlist: [
      "/january-december-2026-paw-print-dog-calendar-stcj",
      "/january-december-2026-paw-print-cat-calendar-stcj",
    ],
    salesPages,
    ...specificEnvironmentConfig,
  };
})();
